import { Owner as OwnerDTO, OwnerAdmittedCount, OwnerFilter } from '@/api/owner/types';
import { PaginatedResponseContent }  from '@/api/types';

export interface Owner {
  ownerAdmittedContext: OwnerAdmittedCount | null;
  ownerAdmittedStatus: string;
  ownerContext: OwnerDTO | null;
  status: string;
  errorContext: OwnerDTO | null;
  ownersContext: PaginatedResponseContent<OwnerDTO> | null;
  ownersStatus: string;
  ownersFilter: OwnerFilter;
}

export const AdmittedStatus = {
  FETCHING: "fetching:admitted",
  FETCH: "fetch:admitted",
  FETCH_FAILED: "fetch-failed:admitted"
}
